module.exports = __webpack_public_path__ + "static/media/deep_vertical_domain_knowledge_bg.b5c3438d.png";